import React from 'react';
import { Container } from 'reactstrap';
import DataGrid, { Column, Export, ColumnFixing } from 'devextreme-react/data-grid';
import { Link } from 'react-router-dom';
import style from './followup-main.module.scss';
import { Enums } from '@utils';

interface IMainDataGrid{
    dataSource: any,
    columns: any,
    base: string,
    gridProps?: any,
    tableId: string
} 

export const MainDataGrid: React.FC<IMainDataGrid> = ({ dataSource, columns = [], gridProps, base, tableId }) => {
    const cellTemplate = (e:any) => {
        let templateView = 
            (tableId.includes('-project')) ? `${base}view?Code=${e.data.projectCode}&Year=${e.data.year}` 
            : (tableId.includes('-subproject')) ? `${base}view?Id=${e.data.id}` 
            : (tableId.includes('-country')) ? `${base}view?Country=${e.data.country}&Year=${e.data.year}` : ''
        let templateEdit = 
            (tableId.includes('-project')) ? `${base}edit?Code=${e.data.projectCode}&Year=${e.data.year}` 
            : (tableId.includes('-subproject')) ? `${base}edit?Id=${e.data.id}` 
            : (tableId.includes('-country')) ? `${base}edit?Country=${e.data.country}&Year=${e.data.year}` : ''
        return (
            <div className={style.iconDetailContainer}>               
                <Link to={templateView}>
                    <i className="dx-icon-bulletlist"></i>
                </Link>                
                {(e.data.allowCode === Enums.FollowupState.edit && e.data.canEdit) ? 
                    <Link to={templateEdit}>
                        <i className="dx-icon-edit"></i>
                    </Link>
                    : <div></div>
                } 
            </div> 
        );
    }
    const groupTemplated = (e:any) => {          
        return <label>{`${e.column.caption}: ${e.displayValue}`}</label>;
    }
    const getColumns = () => { 
        if(columns.length > 0){
            return columns.map((x: any, index:number) => {
                let props = {...x}
                if(x.groupIndex !== null && x.groupIndex !== undefined){
                    props = {...x, groupCellRender: groupTemplated, alignment:"center"}
                }
                return <Column key={index} {...props}/>
            })
        } 
    }
    
    return (
        <Container >
            <DataGrid
            className={style.container}
            dataSource={dataSource}
            allowColumnReordering={true}
            rowAlternationEnabled={true}
            showRowLines={true}
            hoverStateEnabled={true}
            wordWrapEnabled ={true}
            allowColumnResizing={true}
            showBorders={true}
            {...gridProps }>
                {getColumns()}
                <Column width={70} cellRender={cellTemplate}></Column>
                <Export enabled={true} excelFilterEnabled={true} fileName={"Seguimiento_" + new Date()}/>
                <ColumnFixing enabled={true} />
            </DataGrid>
        </Container>
    );
}

export default MainDataGrid;
